let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6O0Ad")).then(() => parcelRequire('gb3Xv'));